import { ExportFileKind } from '../components/ExportToExcelButton'

import { dateFormats, dateUtils, formatDate } from './dateTimeUtility'

/**
 * Returns correct plural form for the specified `amount`.
 * The `$` symbol will be substituted with the `amount` string.
 * @param amount
 * @param single - The single form.
 * @param plural1 - The first plural form, to go with 2, 3, 4.
 * @param plural2 - The second plural form, to go with 5, 6, 7.
 */
export const pluralize =
  (amount: number, single: string, plural1: string, plural2: string) => {
    const pluralString = amount % 10 === 1 && amount % 100 !== 11
                         ? single
                         : amount % 10 >= 2 && amount % 10 <= 4 && (amount % 100 < 10 || amount % 100 >= 20)
                           ? plural1
                           : plural2

    return pluralString.replaceAll('$', amount.toString())
  }

/**
 * Shorter dash, about half the width of an {@link emDash}, still longer than a hyphen.
 * See {@link https://en.wikipedia.org/wiki/Dash#En_dash}
 */
export const enDash = '–'

/**
 * Long dash, longer than both hyphen and {@link enDash}.
 * See {@link https://en.wikipedia.org/wiki/Dash#Em_dash}.
 */
export const emDash = '—'

/**
 * Characters invalid in file names (Windows).
 * Spaces inside the name are allowed.
 * Leading and trailing whitespace is not handled.
 */
const FILENAME_UNSAFE = /[/\\:*?"<>|]+/g

/**
 * Sanitizes a string to make it safe for use as a file name in Windows.
 */
export const sanitizeFilename = (value: string): string =>
  value.trim().replace(FILENAME_UNSAFE, '_')

export const buildExcelExportFilename =
  (accountName: string | undefined, fileKind: ExportFileKind): string => {
    const dateStr = formatDate(dateUtils.now, dateFormats.dateOnlyFilename)

    const safeAccountName =
      accountName && accountName.trim().length > 0
      ? accountName.trim()
      : 'экспорт'

    const rawName = `${safeAccountName} ${enDash} ${fileKindNames[fileKind]} ${enDash} ${dateStr}`

    return `${sanitizeFilename(rawName)}.xlsx`
  }

const fileKindNames = {
  [ExportFileKind.Products]: 'товары',
  [ExportFileKind.Orders]: 'заказы'
} as const satisfies { [K in ExportFileKind]: string }